import { useFakedUID } from "./useFakeUID";
import useFirebaseData from "./useFirebaseData";
import type { FirebaseRecord, Kiln } from "../types";

const useFirebaseKilns = () => {
  const uid = useFakedUID();
  return useFirebaseData<FirebaseRecord<Kiln>>(uid ? `/userdata/${uid}/kilns` : null);
};

export default useFirebaseKilns;
